import React, { useEffect, useState } from 'react'
import './SignUp.scss'

import logo from '../../assets/images/DashboardImages/logo.svg'
import rightImg from '../../assets/images/DashboardImages/images/signup-img.png'
import userIcon from '../../assets/images/DashboardImages/icons/iconamoon_profile.svg'
import emailIcon from '../../assets/images/DashboardImages/icons/mi_email.svg'
import passIcon from '../../assets/images/DashboardImages/icons/teenyicons_password-outline.svg'
import { Link, useNavigate } from 'react-router-dom'
import eyeIcon from "../../assets/icons/eye.svg"
import closeEyeIcon from "../../assets/icons/eyeclosed.svg"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { auth, firestoredb } from '../../config'
import { doc, setDoc } from 'firebase/firestore'
import { createUserWithEmailAndPassword, onAuthStateChanged, sendEmailVerification, signOut, updateProfile } from 'firebase/auth'
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const SignUp = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    // const [emailError, setEmailError] = useState('');
    // const [passwordError, setPasswordError] = useState('');
    const [fullName, setFullName] = useState('');
    // const [fullNameError, setFullNameError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validateInputs();

        if (isValid.fullName) {
            toast.error(isValid.fullName);
        }
        else if (isValid.email) {
            toast.error(isValid.email);
        }
        else if (isValid.password) {
            toast.error(isValid.password);
        }
        else {
            try {
                await createUserWithEmailAndPassword(auth, email, password)
                    .then(async (res) => {
                        const { user } = res;
                        updateProfile(auth.currentUser, {
                            displayName: fullName,
                        })
                            .then(async () => {
                                await setDoc(doc(firestoredb, "users", user.uid), {
                                    uid: user.uid,
                                    fullName: fullName,
                                    userEmail: email,
                                    userBio: "",
                                    gender: "",
                                    phoneNumber: "",
                                    address: ""

                                })
                                    .then((res1) => {
                                        const userData = {
                                            email: user.email,
                                            name: user.displayName,
                                            uid: user.uid,

                                        };
                                        const jsonString = JSON.stringify(userData);
                                        localStorage.setItem("resumebuilderuser", jsonString);
                                        toast("Signup success", { toastId: "userloggedin" });

                                        // sendEmailVerification(auth.currentUser)
                                        //     .then((res) => {
                                        //         // console.log(res);
                                        //     })
                                        //     .catch((err) => {
                                        //         // console.log(err);
                                        //     });

                                        signOut(auth)
                                            .then(() => {
                                                // console.log("User signed out successfully.");
                                                navigate("/login");
                                            })
                                            .catch((error) => {
                                                // console.log("Error signing out:", error);
                                            });
                                    })
                                    .catch((error) => {
                                        // console.log(error);
                                        return false;
                                    });
                            })
                            .catch((error) => {
                                // console.log(error);
                                return false;
                            });
                    })
                    .catch((error) => {
                        // console.log(error);
                        if (
                            error ==
                            "FirebaseError: Firebase: Error (auth/email-already-in-use)."
                        ) {
                            toast("This email is already Registered", {
                                toastId: "alreadyRegistered",
                            });
                        }
                        return false;
                    });
            } catch (err) {
                console.error(err);
                alert(err.message);
                return false;
            }
        }


    };

    const validateInputs = () => {
        let error = {};

        if (!fullName) {
            // setFullNameError('Full Name is required');
            error = { fullName: 'Full Name is required' };
        }
        if (!email || !emailRegex.test(email)) {
            // setEmailError('Invalid email format');
            error = { ...error, email: 'Invalid email format' };

        }
        if (!password || password.length < 6) {
            // setPasswordError('Password must be at least 6 characters long');
            error = { ...error, password: 'Password must be at least 6 characters long' };

        }

        return error;

    };

    useEffect(() => {
        // const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in.
                const { uid } = user;
                navigate("/dashboard");
                // setUserisLogged(true);
            } else {
                // User is signed out.
                // setUserisLogged(false);

                // router.push({
                //     pathname: "/login",
                // });
            }
        });
        return () => unsubscribe();
    }, []);

    return (
        <div>
            <img src={logo} alt='' className='logo-dash' />
            <form className='credentional-main-container' onSubmit={handleSubmit}>
                <div className='credentional-main-left-container'>
                    <div className='credentional-left-centered-container'>
                        <h3>Sign Up</h3>

                        <span><img src={userIcon} alt='' />
                            <input type='text' placeholder='Full Name' value={fullName} onChange={(e) => setFullName(e.target.value)} />
                        </span>
                        <span><img src={emailIcon} alt='' />
                            <input type='text' placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} />
                        </span>
                        <span>
                            <img src={passIcon} alt='' />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder='Password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            {showPassword ? (
                                <img
                                    src={eyeIcon}
                                    alt='Hide Password'
                                    className='eye-icon'
                                    onClick={() => setShowPassword(false)}
                                />
                            ) : (
                                <img src={closeEyeIcon} alt='Show Password' className='eye-icon' onClick={() => setShowPassword(true)} />
                            )}
                        </span>

                        <button className='themebtn-1' type='submit'>Create account</button>
                        <p>Already account?<Link to="/login" className='login-Link'>Log In</Link></p>
                    </div>
                </div>
                <div className='credentional-main-right-container'>
                    <img src={rightImg} alt='' />
                </div>
            </form>
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    )
}

export default SignUp